import { useEffect, useState } from 'react'

const STORAGE_KEY = 'color-theme'

const useColorMode = () => {
    const [colorMode, setColorMode] = useState(() => {
        if (typeof window === 'undefined') return 'light'
        return localStorage.getItem(STORAGE_KEY) || 'light'
    })

    useEffect(() => {
        const className = 'dark'
        const root = window.document.documentElement
        colorMode === 'dark' ? root.classList.add(className) : root.classList.remove(className)
        localStorage.setItem(STORAGE_KEY, colorMode)
    }, [colorMode])

    return [colorMode, setColorMode]
}

export default useColorMode
